import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconContentCopy, IconFileCopy } from '@travel-frontend/icons';
import { forwardRef, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Slide } from 'react-toastify';
import { Container } from '../../../../components/Voucher/components/Copy/components/Container.js';
import { ActionLink, Toast } from '../../../../primitives/index.js';
import { useToast } from '../../../../primitives/Toast/hooks/useToast.js';
const CopyComponent = forwardRef(({
  code,
  hidden,
  onCopy,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation('voucher');
  const toast = useToast();
  const [isCopyClicked, setIsCopyClicked] = useState(false);
  const timeoutRef = useRef();
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return _jsxs(Container, {
    isHidden: hidden,
    ref: ref,
    ...props,
    children: [_jsx(ActionLink, {
      "aria-label": t('buttonAriaLabel'),
      onClick: () => {
        navigator.clipboard.writeText(code);
        setIsCopyClicked(true);
        toast({
          caption: t('toastCaption'),
          variant: 'success',
          containerId: code
        });
        timeoutRef.current = setTimeout(() => setIsCopyClicked(false), 4500);
        onCopy?.();
      },
      disabled: isCopyClicked,
      children: isCopyClicked ? _jsx(IconFileCopy, {}) : _jsx(IconContentCopy, {})
    }), _jsx(Toast, {
      containerId: code,
      autoClose: 4000,
      position: "bottom-center",
      transition: Slide
    })]
  });
});
CopyComponent.displayName = 'Copy';
export const Copy = /*#__PURE__*/_styled(CopyComponent, process.env.NODE_ENV === "production" ? {
  target: "e14c4bpn0"
} : {
  target: "e14c4bpn0",
  label: "Copy"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");